import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=1099d952&scoped=true"
import script from "./ClientList.vue?vue&type=script&lang=ts"
export * from "./ClientList.vue?vue&type=script&lang=ts"
import style0 from "./ClientList.vue?vue&type=style&index=0&id=1099d952&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1099d952",
  null
  
)

export default component.exports